const AudioS3 = ({ linkS3, link }) => {
  if (linkS3 && linkS3 !== "not-exists" && !linkS3.includes("error")) {
    return <audio src={linkS3} controls autoPlay={false} />;
  }

  if (link) return <audio src={link} controls autoPlay={false} />;

  return null;
};

export default AudioS3;
